import { bus } from "@/main";
import VueCookies from "vue-cookies";
import { ProjectApplication } from "@/data/classes/project.class";
import { createProjectEntry, getProjectsList } from "@/data/models/project.model";
import { getSchoolsList } from "@/data/models/school.model";

export default {
	name: "ProjectsPage",
	data() {
		return {
			content: null,
			isReady: false,
			currentPage: 1,
			totalPages: null,
			totalEntries: null,
			projectModal: false,
			projectForm: {
				title: null,
				titleEng: null,
				course: null,
				courseEng: null,
				class: null,
				classEng: null,
				schools: []
			},
		}
	},
	created () {
		this.getContent();
		bus.$on("deleteSession", () => {
			this.getContent();
		})
		bus.$on("userSession", () => {
			this.getContent();
		})
		bus.$on("projectDeleted", () => {
			console.log("Project DELETED !!!")
			this.content = null;
			this.getContent();
		})
	},
	computed: {
		pageUrl: function() {
			return location.href;
		}
	},
	mounted () {},
	watch: {
		"$route": function () {
			this.getContent();
			language: this.$route.params.lang
		}
	},
	methods: {
		getContent() {
			let user = VueCookies.get("user")
			if (user.username == "admin" || user.username == "projetoescolas") {
				getProjectsList(1, 1).then(content => {
					this.content = content;
					this.isReady = true;
					this.totalPages = content.totalPages;
					this.totalEntries = content.totalEntries;
				});
			} else {
				getProjectsList(1, 1, user.id).then(content => {
					this.content = content;
					this.isReady = true;
					this.totalPages = content.totalPages;
					this.totalEntries = content.totalEntries;
				});
				getSchoolsList(1, 1, user.id).then(content => {
					this.projectForm.schools[0] = content.content[0];
				});
			}
		},
		getMoreContent(currentPage) {
			let user = VueCookies.get("user");
			if (user.username == "admin" || user.username == "projetoescolas") {
				getProjectsList(1, currentPage).then(content => {
					this.content.content = content.content;
					this.totalPages = content.totalPages;
					this.totalEmtries = content.totalEmtries;
					this.currentPage = currentPage;
				});
			} else {
				getProjectsList(1, currentPage, user.id).then(content => {
					this.content.content = content.content;
					this.currentPage = currentPage;
				});
			}
		},
		submitProject() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					let user = VueCookies.get("user");
					// eslint-disable-next-line
					createProjectEntry(new ProjectApplication(this.projectForm)).then(response => {
						console.debug("Application creation response:", response);
						if (response.status == 201) {
							this.$router.replace({ "hash": "sent" });
							bus.$emit('notification', "📝 Projeto Criado!")
							this.projectModal = false
							this.getContent();
						}
					}).catch(error => {
						this.throwError(error);
					});
				} else {
					console.debug("Form is not valid!");
				}
			});
		},
		modalClose() {
			bus.$emit('modalClose');
		},
		modalOpen() {
			bus.$emit('modalOpen');
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/projects.page.js